import { render, staticRenderFns } from "./StaticPlatformUpload.vue?vue&type=template&id=75bbe3ce&scoped=true&"
import script from "./StaticPlatformUpload.vue?vue&type=script&lang=js&"
export * from "./StaticPlatformUpload.vue?vue&type=script&lang=js&"
import style0 from "./StaticPlatformUpload.vue?vue&type=style&index=0&id=75bbe3ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbe3ce",
  null
  
)

export default component.exports